export default {
  logTracking: {
    title: "日志追踪",
    component: () => import("@/mods/system/logManage/detailView/LogTracking"),
  },
};
